import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { CYBERSOURCE_SETUP_PAYER_AUTH } from "../graphql/cybersourceSetupPayerAuth.mutation";

const log: any = LoggerModule?.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPayNowMethods extends IPluginMethodMap {
  cybersourceSetupPayerAuth(args: any): Promise<any>;
}

export class PayNowService implements IAgentPlugin {
  readonly methods: IPayNowMethods;

  constructor() {
    this.methods = {
      cybersourceSetupPayerAuth: this.cybersourceSetupPayerAuth.bind(this),
    };
  }

  async cybersourceSetupPayerAuth(args: any) {
    log.blue("cybersourceSetupPayerAuth args:", args);

    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    if (!client) {
      throw new Error("GraphQL client not found");
    }

    const input = args?.data || {};

    const data: any = {
      payOrder: input?.payOrder,
      amount: Number(input?.amount),
      sessionId: input?.sessionId,
      transientToken: input?.transientToken,

      firstName: input?.firstName,
      lastName: input?.lastName,
      email: input?.email,
      mobile: input?.mobile,
      addressLine1: input?.addressLine1,
      city: input?.city,
      state: input?.state,
      country: String(input?.country || "").toUpperCase(),
      postalCode: input?.postalCode,
      browserLanguage: input?.browserLanguage,
      browserUserAgent: input?.browserUserAgent,
      browserAcceptHeader: input?.browserAcceptHeader,
      browserJavaEnabled: input?.browserJavaEnabled,
      browserJavaScriptEnabled: input?.browserJavaScriptEnabled,
      browserColorDepth: input?.browserColorDepth,
      browserScreenHeight: input?.browserScreenHeight,
      browserScreenWidth: input?.browserScreenWidth,
      browserTimeZone: input?.browserTimeZone,
      returnUrl: input?.returnUrl,
    };
    // TEMP: Platform Fee disabled until backend deployment
    if (input?.platformFee !== undefined && input?.platformFee !== null) {
      data.platformFee = input.platformFee;
    }
    if (Array.isArray(input?.allocations) && input.allocations.length > 0) {
      data.allocations = input.allocations;
    }
    try {
      const res = await client.mutate({
        mutation: CYBERSOURCE_SETUP_PAYER_AUTH,
        variables: { data },
        fetchPolicy: "no-cache",
      });

      return {
        res: res?.data?.cybersourceSetupPayerAuth,
        url: null,
      };
    } catch (err: any) {
      const displayMessage =
        err?.graphQLErrors?.find((item: any) => item?.extensions)?.extensions
          ?.display_message ||
        err?.message ||
        "CyberSource payer authentication failed";

      throw new Error(displayMessage);
    }
  }
}
